import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { SalesServiceService } from '../../sales/services/sales-service.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthServiceService } from '../../auth/services/auth-service.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  public boolie: boolean;
  message:string;
  menu_data:any = [];
  constructor(private data: SalesServiceService, private toastr: ToastrService, private router: Router,private authenticationService: AuthServiceService, private elementRef: ElementRef) {
    this.boolie = true;
    this.getMenu();
  }

  ngOnInit() {
  }

  /**
   * Cierra el menú al hacer clic en cualquier parte fuera de él.
   *
   * `boolie` en true significa colapsado, así que solo hay algo que hacer cuando está en
   * false. Los clics dentro del menú no entran acá porque se descarta lo que esté contenido
   * en el elemento del componente: eso incluye el pie que lo minimiza y los ítems de menú,
   * que ya cierran por su cuenta al navegar.
   */
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.boolie) {
      return;
    }
    const target = event.target as Node;
    // Un clic sobre algo que ya se quitó del DOM (un modal que se cerró, una fila que
    // desapareció) no está contenido en ninguna parte: no se cierra por eso.
    if (!target || !document.contains(target)) {
      return;
    }
    if (!this.elementRef.nativeElement.contains(target)) {
      this.collapseSidebar();
    }
  }

  /**
   * Colapsa el menú y avisa al resto del layout, igual que expandSidebar().
   *
   * Se separa en vez de llamar a expandSidebar() porque ese método hace un subscribe en cada
   * llamada, y este se dispara desde un listener de documento: reusarlo iría acumulando
   * suscripciones.
   */
  collapseSidebar(): void {
    this.boolie = true;
    this.data.changeMessage('change');
  }

  getMenu(){
    this.authenticationService.getMenuData()
        .subscribe(
          result => {
            this.menu_data = result;
          },
          error => {
            if (error.error.detail === 'Signature has expired.') {
              this.toastr.warning('Por favor vuelve a iniciar sesion', 'Sesion expirada');
              localStorage.clear();
              this.router.navigate(['/auth/login']);
            }
          });
  }

  expandSidebar(): void {
  	this.boolie = !this.boolie
  	this.data.changeMessage('change');
  	this.data.currentMessage.subscribe(message => this.message = message)
  }
  goOut(): void {
    this.toastr.info("Has cerrado sesión exitosamente", "Hasta pronto");
    localStorage.clear();
    this.router.navigate(['/auth/login']);
  }

  sortBy(prop: string, array:any) {
    return array.sort((a, b) => a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1);
  }


}
